var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "specialty-information mt-1" }, [
    _c("div", { staticClass: "row header" }, [
      _c("div", { staticClass: "col-12 mb-0 mt-2 pt-2 pb-2 ml-3" }, [
        _c("em", {
          staticClass:
            "fas rounded-circle p-1 mr-2 color-green shadow bg-white",
          class: _vm.editModel.isNew ? "fa-plus" : "fa-edit"
        }),
        _c("span", [
          _vm._v(
            _vm._s(_vm.editModel.isNew ? "Añadir" : "Editar") + " Especialidad"
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "row body" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          { staticClass: "col-xs-12" },
          [
            _c(
              "validation-observer",
              { ref: "formValidator" },
              [
                _c("specialty-information", {
                  attrs: { "used-specialties": _vm.usedSpecialties },
                  model: {
                    value: _vm.editModel,
                    callback: function($$v) {
                      _vm.editModel = $$v
                    },
                    expression: "editModel"
                  }
                }),
                _vm.customErrorMessage != null
                  ? _c("error", {
                      attrs: {
                        message: _vm.customErrorMessage,
                        variant: "no-border"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 pb-2" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-12 text-right mr-0 mr-md-3 mr-sm-0 actions d-flex d-md-block d-sm-flex justify-content-center align-items-center px-5 mt-3 mt-md-0 mt-sm-3"
              },
              [
                _c("action-button", {
                  staticClass: "mr-2 py-2 btnCancel",
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger"
                  },
                  on: { click: _vm.cancel }
                }),
                _c("action-button", {
                  staticClass: "py-2",
                  attrs: {
                    i: "fas fa-plus",
                    text: "Añadir",
                    variant: "success"
                  },
                  on: { click: _vm.save }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }